<div class="modal-header" mat-dialog-title>
  <div class="modal-header-titles">
    <h2 class="modal-title">Enviar cotação</h2>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar" (click)="fechar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  <p>
    A cotação será enviada por e-mail para <strong>{{ data.nomeFornecedor }}</strong>
    usando o template configurado em Comunicação de cotação.
  </p>
  <mat-form-field appearance="outline" class="w-100">
    <mat-label>E-mail do fornecedor</mat-label>
    <mat-icon matPrefix class="material-symbols-outlined">mail</mat-icon>
    <input matInput type="email" [(ngModel)]="destinatario" placeholder="fornecedor@empresa.com.br"
      (keydown.enter)="confirmar()">
    @if (!data.destinatarioPadrao) {
      <mat-hint>Este fornecedor não tem e-mail cadastrado. Informe um endereço para enviar.</mat-hint>
    }
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
  <button mat-stroked-button type="button" class="btn-secondary" (click)="fechar()">Cancelar</button>
  <span matTooltip="Informe um e-mail válido para enviar." [matTooltipDisabled]="isValido()">
    <button mat-flat-button type="button" class="btn-primary" [disabled]="!isValido()" (click)="confirmar()">
      <mat-icon class="material-symbols-outlined">send</mat-icon>
      Enviar cotação
    </button>
  </span>
</mat-dialog-actions>
